import fx from "../../utils/fx";
import AxiosInterceptor from 'api/interceptor';

const advocates = new AxiosInterceptor();
export default {
    get(qstr) {
        qstr = fx.urlQueryString(qstr, false);
        return advocates.get("referrals/get-advocates?" + qstr);
      },
};